<xi-drawer
  [open]="open"
  [interceptClose]="true"
  (onClose)="onCancel()"
  *transloco="let t; read: 'action-plan-settings-drawer-component'"
>
  <div slot="title">{{ t('basic-settings') }}</div>
  <div slot="body" class="action-plan-settings-drawer__body">
    <div class="action-plan-settings-drawer__container">
      <div class="action-plan-settings-drawer__title">{{ t('basic-settings') }}</div>

      <form [formGroup]="form" class="action-plan-settings-drawer__section-content">
        <div class="action-plan-settings-drawer__label">
          {{ t('breakdown-field') }}
        </div>
        <div class="action-plan-settings-drawer__blue-bill-wrapper full">
          <app-lex-blue-pill [text]="actionPlan.metadata.breakdown"></app-lex-blue-pill>
        </div>

        <div class="action-plan-settings-drawer__label">
          {{ t('driver') }}
        </div>
        <div class="action-plan-settings-drawer__blue-bill-wrapper full">
          <app-lex-blue-pill [text]="actionPlan.metric_name"></app-lex-blue-pill>
        </div>

        <div class="action-plan-settings-drawer__label">
          {{ t('due-date') }}
        </div>
        <div class="action-plan-settings-drawer__due-date-picker-wrapper">
          <xi-date-picker
            [status]="dueDateStatus"
            [minDate]="minDueDate"
            [dateValue]="form.controls.dueDate.value"
            formControlName="dueDate"
            placeholder="{{ t('placeholder') }}"
          ></xi-date-picker>
        </div>

        <div class="action-plan-settings-drawer__label">
          {{ t('recent-score') }}
        </div>
        <div class="action-plan-settings-drawer__blue-bill-wrapper recent-score">
          <app-lex-blue-pill
            [text]="actionPlan.metric_original_value | number: '1.0-1'"
            textAlign="center"
          ></app-lex-blue-pill>
        </div>

        <div class="action-plan-settings-drawer__label">
          {{ t('target-score') }}
        </div>
        <app-lex-horizontal-stepper
          [value]="targetScore"
          [originalValue]="actionPlan.metric_original_value"
          [scale]="scale"
          size="normal"
          [allowNegative]="actionPlan.metadata.scoringStrategy === 'NPS'"
          [allowFractional]="true"
          [decimals]="1"
          [disabled]="isReadOnly"
          (valueChange)="onTargetScoreValueChanged($event)"
        ></app-lex-horizontal-stepper>

        <div class="action-plan-settings-drawer__label">
          {{ t('note') }}
        </div>
        <xi-text-area formControlName="notes" placeholder="{{ t('note-placeholder') }}" type="text">
        </xi-text-area>
      </form>
    </div>
  </div>

  <div slot="footer" class="action-plan-settings-drawer__footer">
    <xi-default-button
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="onCancel()"
    ></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        text="{{ t('save') }}"
        [disabled]="!form.valid || !hasChanges"
        (onClick)="onSave()"
      ></xi-default-button>
      @if (isSaving) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</xi-drawer>
